export class Unauthorized extends Error {
    private readonly status = 401;

    constructor(response: string | Record<string, any>){
        super(response as string);
        //this.status = status;
    }
}